import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function idiomaReducer(state= initialState.idioma, action){
	
	switch(action.type){
		case types.SET_IDIOMA:	            
			return action.datos;
		//break;		
	
		default:
			return state;
	}
}